import * as Errors from '../aeppic/errors/index.js'

// Symbol.asyncIterator polyfill
if (!Symbol.asyncIterator) {
  (Symbol as any).asyncIterator = Symbol.for('Symbol.asyncIterator')
}

export { default } from './aeppic.js'
export * from './warn.js'
export * from './aeppic.js'
export * from './cached-query-api.js'
export * from './commands/index.js'
export * from './actions.js'
export { WriteLockedAeppic } from './write-locked-aeppic.js'
// export { SignatureStats, wrapWithSignatureTracking } from './signature-track.js'

export { Errors }
export { BOOT_MARK_PREFIX } from './utils/boot-progress.js'
export type { BootPhase, BootProgressCallback } from './utils/boot-progress.js'
export { Router } from './router.js'
export type { IRouter } from './router.js'

export { WebSocketConnection } from './websocket/index.js'
